import {HomeScreen, MenuScreen, ContactScreen, ErrorScreen} from './screen'
import {BrowserRouter, Route, Switch} from 'react-router-dom'

import {Navbar, Sidebar, Footer, WrapperParallax} from './components'

function App() {
  return (
    <WrapperParallax>
    <BrowserRouter>
      <Navbar/>
      <Sidebar/>
      <Switch>
        <Route path="/" exact component={HomeScreen}/>
        <Route path="/menu" component={MenuScreen}/>
        <Route path="/contattaci" component={ContactScreen}/>
        <Route path="*" component={ErrorScreen}/>
      </Switch>
      <Footer/>
    </BrowserRouter>
    </WrapperParallax>
  );
}

export default App;
